export default __webpack_public_path__ + "static/media/Group 6179.2e99f492.svg";